import { goesLoadingPaths } from "./goes-loading-paths";

const GOESLoading = () => {
  return (
    <svg
      width="134"
      height="164"
      viewBox="0 0 134 164"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="goes-loading"
    >
      {goesLoadingPaths}
    </svg>
  );
};

export default GOESLoading;
